var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            disabled:
              !_vm.hotel || (_vm.hotel && !_vm.hotel.bookable_via_iescape),
            href: _vm.onboardUrl,
            title: "Onboard property",
          },
        },
        [_c("v-icon", [_vm._v("list")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            disabled:
              !_vm.hotel || (_vm.hotel && !_vm.hotel.bookable_via_iescape),
            href: _vm.reservationsUrl,
            title: "Reservation management",
          },
        },
        [_c("v-icon", [_vm._v("hotel")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: { href: _vm.editUrl, title: "Property details" },
        },
        [_c("v-icon", [_vm._v("edit")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: { href: _vm.facilitiesUrl, title: "Facility management" },
        },
        [_c("v-icon", [_vm._v("pool")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: { href: _vm.imageLibraryUrl, title: "Image library" },
        },
        [_c("v-icon", [_vm._v("insert_photo")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            disabled:
              !_vm.hotel ||
              (_vm.hotel &&
                (_vm.hotel.is_tailormade_tour ||
                  !_vm.hotel.bookable_via_iescape)),
            href: _vm.cloneRateDatesUrl,
            title: "Clone rate dates",
          },
        },
        [_c("v-icon", [_vm._v("content_copy")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            disabled:
              !_vm.hotel || (_vm.hotel && !_vm.hotel.bookable_via_iescape),
            href: _vm.dailyPlannerUrl,
            title: "Daily planner",
          },
        },
        [_c("v-icon", [_vm._v("edit_calendar")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            disabled:
              !_vm.hotel ||
              (_vm.hotel &&
                (_vm.hotel.is_tailormade_tour ||
                  !_vm.hotel.bookable_via_iescape)),
            href: _vm.batchLoaderUrl,
            title: "Batch loader",
          },
        },
        [_c("v-icon", [_vm._v("file_upload")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: { href: _vm.viewLiveUrl, title: "Live overview page" },
        },
        [_c("v-icon", [_vm._v("web")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "mt-1",
          attrs: {
            title: "Additional fees",
            disabled:
              !_vm.hotel || (_vm.hotel && !_vm.hotel.bookable_via_iescape),
            href: _vm.additionalFeesUrl,
          },
        },
        [_c("v-icon", [_vm._v("attach_money")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }